import { render } from "./TimeReports.vue?vue&type=template&id=265a1ede"
import script from "./TimeReports.vue?vue&type=script&lang=js"
export * from "./TimeReports.vue?vue&type=script&lang=js"

import "./TimeReports.vue?vue&type=style&index=0&id=265a1ede&lang=css"
script.render = render

export default script